import {
  DialogContent,
  LinearProgress,
  Dialog as DialogComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts, margins } from '~/layout';

export const ProgressBar = lib.styled(LinearProgress)`
  && {
    background-color: ${colors.white};
  }

  .MuiLinearProgress-barColorPrimary {
    background-color: ${props => props.colors};
  }
`;

export const Dialog = lib.styled(DialogComponent)`
  .MuiDialog-paperWidthSm {
    width: 360px;
  }
`;

export const DialogTitle = lib.styled.div`
  display: flex;
  height: 60px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background-color: ${colors.lightGray}
  font-weight: bold;

  span {
    left: 33%;
    position: absolute;
  }
`;

export const BackButton = lib.styled.a`
  color: ${colors.black};
  opacity: .5;
  &:hover {
    color: ${colors.lightBlue};
  }
  font-size: ${fonts.default}px;
  font-weight: 600;
  margin-right: ${margins.links}px;
  cursor: pointer;
  margin-left: auto;
`;

export const TextArea = lib.styled.textarea`
 width: 100%!important;
 height: 100px;
 font-size: 14px;
 font-family: Nunito!important;
 resize: none;
 overflow: auto;
 outline: none;
 border: none;
`;

export const DialogContents = lib.styled(DialogContent)`
  display: flex;
  flex-direction: column;
  padding: 10px 5px 0 5px !important;
`;

export const Row = lib.styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonStyled = lib.styled.button`
  display: flex;
  width: 85px;
  height: 26px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  font-weight: 800;
  font-family: Nunito!important;
  color: #FFF;
  border-width: 0px;
  border-radius: 50px;
  cursor: pointer;
  background: linear-gradient(50.28deg,#67C2E4 2.79%,#0C4BBC 73.37%);
  margin: 10px 0 10px 0;
  &:focus {
    outline: 0;
  }

  .loader {
    color: ${colors.white}
  }
`;

export const Word = lib.styled.span`
  color: ${props => props.color};
  font-size: ${fonts.default}px;
  max-width: 338px;
  margin-top: 5px;

  .char {
    font-size: 18px;
    color: ${colors.red};
    margin-right: 3px;
  }
`;

export const SendMessage = lib.styled.div`
  display: flex;
  width: 332px;
  height: 292px;
  flex-direction: column;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  .success {
    padding-top: 10px;
    max-width: 147px;
    text-align: center;
  }

  .error {
    padding-top: 10px;
    max-width: 220px;
    text-align: center;
  }
`;

export const MessageBtn = lib.styled.a`
  color: ${colors.black};
  font-size: ${fonts.default}px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  align-self: flex-end;
  position: absolute;
  bottom: 0px;
  padding: 18px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

export const Destination = lib.styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: ${fonts.default}px;
  font-color: ${colors.lightGray};
  padding: 5px 5px 3px 5px;

  .dest {
    background-color: ${colors.lightGray};
    border-radius: 5px;
    padding: 2px 5px 2px 5px;
    color: ${colors.green01};
    /* margin-left: 21px; */
    padding-top: 3px;
    font-weight: 600;
  }

  .title {
    min-width: 40px;
  }

  select {
    width: 90%;
    border: 1px solid ${colors.lightGray};
    border-radius: 5px;
    margin: 0 5px 0 0px;
    padding: 2px 5px 2px 5px;
  }

  select:focus {
    outline: none;
  }

  .group-centered {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .helper {
    width: 16px;
    height: 16px;
    border: 1px solid ${colors.lightGray};
    border-radius: 100%;
    padding: 2px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }

  .helper:hover {
    background: ${colors.lightGray};
  }
`;
